const url = 'https://testsupport.asseco-see.hr/live20Rest';

export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  apiUrl: `${url}/services`,
  apiUrlLogin: `${url}/login`,
  apiUrlRequestAccess: `${url}/requestaccess`,
  apiUrlForgotPassword: `${url}/forgotpassword`,
  uploadUrl: `${url}/upload`,
  downloadUrl: `${url}/download/get`,
  reCaptchaSiteKey: '6LfNmEQUAAAAANafe-5INcXXva1xFQo_VjwoCn5g'
};
